<template>
    <div class="invoice_box safe-distance-top-header-two">
        <headerCom pageTitle="查看发票" />
        <van-cell-group class="invoice_form_group">
            <div class="step_box">
                <div class="step_point_box">
                    <div :class="['step_point_item', index === stepList.length - 1 ? 'flex_none' : '']"
                        v-for="(item, index) in stepList" :key="index">
                        <div class="step_text">{{ item }}</div>
                        <div class="step_point_line"></div>
                        <div :class="['step_point', index === stepList.length - 1 ? 'p_right ' : 'p_left']"><i></i></div>
                    </div>
                </div>
            </div>
        </van-cell-group>
        <van-cell-group class="invoice_form_group refuse_box" v-if="invoiceInfo.progressStatus === 3">
            <h3 class="refuse_title">驳回原因</h3>
            <p class="refuse_content" v-html="invoiceInfo.refuseReason"></p>
        </van-cell-group>
        <van-cell-group class="invoice_form_group invoice_info_box">
            <p class="invoice_item">
                <span class="invoice_label">抬头类型</span>
                <span class="invoice_content">{{ invoiceInfo.headerType | headerTypeFilter }}</span>
            </p>
            <p class="invoice_item">
                <span class="invoice_label">发票类型</span>
                <span class="invoice_content">增值税普通发票</span>
            </p>
            <p class="invoice_item">
                <span class="invoice_label">发票抬头</span>
                <span
                    :class="['invoice_content', invoiceInfo.invoiceHeader && invoiceInfo.invoiceHeader !== '' ? '' : 'invoice_content_null']">{{
                        invoiceInfo.invoiceHeader | isNullFirlter }}</span>
            </p>
            <p v-if="invoiceInfo.headerType === 1" class="invoice_item">
                <span class="invoice_label">纳税人识别号</span>
                <span
                    :class="['invoice_content', invoiceInfo.taxpayerNm && invoiceInfo.taxpayerNm !== '' ? '' : 'invoice_content_null']">{{
                        invoiceInfo.taxpayerNm | isNullFirlter }}</span>
            </p>
            <p v-if="invoiceInfo.headerType === 1" class="invoice_item">
                <span class="invoice_label">开户银行</span>
                <span
                    :class="['invoice_content', invoiceInfo.openingBank && invoiceInfo.openingBank !== '' ? '' : 'invoice_content_null']">{{
                        invoiceInfo.openingBank | isNullFirlter }}</span>
            </p>
            <p v-if="invoiceInfo.headerType === 1" class="invoice_item">
                <span class="invoice_label">银行账号</span>
                <span
                    :class="['invoice_content', invoiceInfo.bankAccount && invoiceInfo.bankAccount !== '' ? '' : 'invoice_content_null']">{{
                        invoiceInfo.bankAccount | isNullFirlter }}</span>
            </p>
            <p v-if="invoiceInfo.headerType === 1" class="invoice_item">
                <span class="invoice_label">注册地址</span>
                <span
                    :class="['invoice_content', invoiceInfo.unitAddr && invoiceInfo.unitAddr !== '' ? '' : 'invoice_content_null']">{{
                        invoiceInfo.unitAddr | isNullFirlter }}</span>
            </p>
            <p v-if="invoiceInfo.headerType === 1" class="invoice_item">
                <span class="invoice_label">注册电话</span>
                <span
                    :class="['invoice_content', invoiceInfo.unitPhone && invoiceInfo.unitPhone !== '' ? '' : 'invoice_content_null']">{{
                        invoiceInfo.unitPhone | isNullFirlter }}</span>
            </p>
        </van-cell-group>
        <van-cell-group class="invoice_form_group" v-if="invoiceInfo.progressStatus === 1">
            <van-cell class="invoice_cell" title="发票" value="共1张（点击查看发票）" is-link @click="toOpen"></van-cell>
        </van-cell-group>
        <div class="invoice_form_btn_box" v-if="invoiceInfo.progressStatus !== 1 && invoiceInfo.progressStatus !== 2">
            <van-button v-if="invoiceInfo.progressStatus === 0" class="invoice_form_btn" round
                @click="changeModalShow = true">撤销申请</van-button>
            <van-button v-if="invoiceInfo.progressStatus === 3" class="invoice_form_btn" round
                @click="toAgain">重新开票</van-button>
        </div>
        <TipsDialog :showDialog="changeModalShow" @dialogCancel="changeModalShow = false" @dialogConfirm="toRepealInvoice"
            @clickOverlay="changeModalShow = false">
            确认撤销该发票申请？
        </TipsDialog>
    </div>
</template>

<script>
import { Toast } from "vant";
import Header from "@/views/mobileView/components/header";
import TipsDialog from "@/views/mobileView/components/tipsDialog.vue";
export default {
    name: 'CheckInvoice',
    components: {
        'headerCom': Header,
        TipsDialog,
    },
    data() {
        return {
            invoiceInfo: {},
            stepList: ['申请开票', '开票中'],
            changeModalShow: false,
        }
    },
    created() {
        this.getInvoiceInfo()
    },
    filters: {
        headerTypeFilter(value) {
            return value === 0 ? '个人' : '企业'
        },
        isNullFirlter(value) {
            return value && value !== '' ? value : '未填写'
        },
    },
    methods: {
        async getInvoiceInfo() {
            const res = await this.$apis.invoiceServe.getInvoiceStatus({
                id: this.$route.query.orderInvoiceId
            })
            if (res.resultCode === '200') {
                this.invoiceInfo = Object.assign({}, res.data)
                // 开票申请状态 0 为待开票。1 已开票。2 已关闭。3 为已拒绝
                if (this.invoiceInfo.progressStatus === 1) {
                    this.stepList.push("已开票")
                } else if (this.invoiceInfo.progressStatus === 2) {
                    this.stepList = ["申请开票", '已关闭']
                } else if (this.invoiceInfo.progressStatus === 3) {
                    this.stepList = ["申请开票", '商家拒绝']
                }
            }
        },
        async toRepealInvoice() {
            const res = await this.$apis.invoiceServe.repealInvoice({
                orderId: this.invoiceInfo.orderId
            })
            if (res.resultCode === '200') {
                Toast('撤销成功')
                this.$router.go(-1)
            } else {
                Toast(res.resultDesc)
            }
        },
        async toOpen() {
            this.$router.push({ name: "openReading", params: { url: this.$global.imgUrl + this.invoiceInfo.filePath, title: '查看发票', canDownLoad: true } });
        },
        toAgain() {
            let query = {
                from: 'invoiceDetail',
                orderInvoiceId: this.$route.query.orderInvoiceId,
                orderId: this.invoiceInfo.orderId,
                invoicePrice: this.invoiceInfo.invoicePrice,
                createTime: this.invoiceInfo.createTime,
            }
            this.$router.push({ path: '/invoice', query })
        },
    },
}

</script>

<style lang='scss' scoped>
.invoice_box {
    width: 100vw;
    padding-bottom: 50px;
    min-height: 100vh;
    background: #f5f5f5;
    overflow: hidden;


    .invoice_form_group {
        margin: 12px auto 0;
        width: 351px;
        border-radius: 8px;
        overflow: hidden;

        .invoice_cell {
            justify-content: space-between;

            &::v-deep .van-cell__title {
                flex: auto;
            }

            &::v-deep .van-cell__value {
                flex: auto;
                font-size: 14px;
                color: #333333;
                text-align: left;
            }
        }

        .invoice_input {
            &::v-deep .van-field__control {
                &:disabled {
                    color: #323233;
                    -webkit-text-fill-color: unset;
                }
            }
        }

        .step_box {
            padding: 0 30px;

            .step_point_box {
                display: flex;
                justify-content: space-between;
                padding: 50px 0 10px;

                .step_point_item {
                    flex: 1;
                    // line-height: 30px;
                    position: relative;

                    .step_text {
                        width: 56px;
                        text-align: center;
                        font-size: 14px;
                        color: #333333;
                        line-height: 20px;
                    }

                    .p_step_text {
                        position: absolute;
                        right: 0;
                    }

                    .step_point_line {
                        position: absolute;
                        top: -23px;
                        width: 100%;
                        // height: 2px;
                        border-top: 4px solid #4A79F1;
                    }

                    .step_point {
                        position: absolute;
                        top: -35px;
                        width: 56px;
                        text-align: center;
                        height: 30px;
                        line-height: 30px;
                        background-color: #fff;

                        i {
                            display: inline-block;
                            width: 14px;
                            height: 14px;
                            background-color: #4A79F1;
                            border-radius: 50%;
                            box-shadow: 0px 1px 5px 0px rgba(74, 121, 241, 0.3);
                            border: 2px solid #FFFFFF;
                        }
                    }

                    .p_right {
                        right: 0;
                    }

                    .p_left {
                        left: 0;
                    }
                }

                .flex_none {
                    flex: none;
                }
            }
        }


    }

    .invoice_info_box {
        padding: 0 12px;

        .invoice_item {
            display: flex;
            padding: 17px 0;
            border-bottom: 1px solid #eee;

            &:last-child {
                border-bottom: none;
            }

            .invoice_label {
                flex: none;
                width: 100px;
                font-size: 14px;
                color: #999999;
                // line-height: 14px;
            }

            .invoice_content {
                font-size: 14px;
                color: #333333;
                word-break: break-all;
                // line-height: 14px;
            }

            .invoice_content_null {
                color: #999;
            }
        }
    }

    .refuse_box {
        padding: 10px 16px;

        .refuse_title {
            margin-bottom: 10px;
            font-size: 16px;
        }

        .refuse_content {
            font-size: 14px;
            line-height: 20px;
            word-break: break-all;
        }
    }

    .invoice_form_btn_box {
        position: fixed;
        bottom: 0;
        left: 0;
        padding: 5px 15px 0;
        padding-bottom: calc(constant(safe-area-inset-bottom) + 10px) !important;
        padding-bottom: calc(env(safe-area-inset-bottom) + 10px) !important;
        width: 100%;
        background-color: #fff;
        text-align: right;

        .invoice_form_btn {
            height: 30px;
        }
    }
}
</style>